export default "__VITE_ASSET__bxotH6tr__"